import React from 'react'

export const QUIET_HOURS_LABEL = '12:00am-8:00am ET'

function getEasternHour(date: Date): number {
  return Number(
    new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      hour12: false,
      timeZone: 'America/New_York',
    }).format(date)
  )
}

export function isQuietHours(date = new Date()): boolean {
  const hour = getEasternHour(date)
  return hour >= 0 && hour < 8
}

export function useQuietHours(refreshMs = 60_000): boolean {
  const [quietHours, setQuietHours] = React.useState(() => isQuietHours())

  React.useEffect(() => {
    const interval = window.setInterval(() => {
      setQuietHours(isQuietHours())
    }, refreshMs)

    return () => window.clearInterval(interval)
  }, [refreshMs])

  return quietHours
}
